const GENDERS = ["MALE", "FEMALE", "OTHERS"];

export default GENDERS;
